module.exports = __webpack_public_path__ + "static/media/whiteClose.7a7591e2.svg";